import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { GetAllTagSetsAcrossAllSpacesBffResponse, TagSetResource, TagSetScope } from "../resources/tagSetResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
export type TagSetListArgs = ListArgs & RouteArgs & {
    partialName?: string;
    scopes?: string[];
    types?: string[];
};
export class TagSetRepository extends BasicRepository<TagSetResource, TagSetResource, TagSetListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("TagSets", client, requestContext);
    }
    sort(ids: string[]) {
        return this.client.put(this.requestContext, this.client.getLink("TagSetSortOrder"), ids);
    }
    allTagSetsAcrossAllSpaces(args?: {
        filterBySpace?: string;
        filterByExcludedSpace?: string;
        scopes?: TagSetScope[];
    }): Promise<GetAllTagSetsAcrossAllSpacesBffResponse> {
        return this.client.get<GetAllTagSetsAcrossAllSpacesBffResponse>(this.requestContext, "~/bff/tagSets{?filterBySpace,filterByExcludedSpace,scopes,types}", args);
    }
    getAllByScopes(scopes: TagSetScope[]): Promise<TagSetResource[]> {
        return this.list({ scopes }).then((collection) => collection.Items);
    }
}
